module.exports = __webpack_public_path__ + "alaska_bg_second.3f2446e.jpg";